// extracted by mini-css-extract-plugin
module.exports = {"colorPicker":"index_colorPicker__3bOON","colorBolck":"index_colorBolck__3t5U0","colorText":"index_colorText__3cmXL","colorBg":"index_colorBg__2fkOP"};